export class AnimationHelper {
  static animate(element: string | any, animation: string, repeat = 0, duration: string = null, prefix = 'animate__'): Promise<any> {
    return new Promise((resolve, reject) => {
      const animationName = `${prefix}${animation}`;
      const node = (typeof element === "string") ? document.querySelector(element) : element;

      node.classList.add(`${prefix}animated`, animationName);

      if (repeat > 0) {
        node.classList.add(`animate__repeat-${repeat}`, animationName);
      }

      if (duration) {
        node.style.setProperty('--animate-duration', duration);
      }

      // When the animation ends, we clean the classes and resolve the Promise
      function handleAnimationEnd() {
        node.classList.remove(`${prefix}animated`, animationName);
        if (repeat > 0) {
          node.classList.remove(`animate__repeat-${repeat}`, animationName);
        }
        resolve('Animation ended');
      }

      node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });
  }
}
